import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';

const App = () => {
  const [authToken, setAuthToken] = useState<string | null>(() => localStorage.getItem('authToken'));
  const [userEmail, setUserEmail] = useState<string>(() => localStorage.getItem('userEmail') || '');
  const [userRole, setUserRole] = useState<string | null>(() => localStorage.getItem('userRole'));
  const isAuthenticated = Boolean(authToken);

  const handleLoginSuccess = (token: string, email: string, role: string) => {
    setAuthToken(token);
    setUserEmail(email);
    setUserRole(role);
    localStorage.setItem('authToken', token);
    localStorage.setItem('userEmail', email);
    localStorage.setItem('userRole', role);
  };

  const handleLogout = () => {
    setAuthToken(null);
    setUserEmail('');
    setUserRole(null);
    localStorage.removeItem('authToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userRole');
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <LoginPage
              onLoginSuccess={handleLoginSuccess}
              isAuthenticated={isAuthenticated}
            />
          }
        />
        <Route
          path="/home"
          element={
            isAuthenticated ? (
              <HomePage
                onLogout={handleLogout}
                token={authToken}
                userEmail={userEmail}
                userRole={userRole || ''}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? '/home' : '/'} replace />}
        />
      </Routes>
    </Router>
  );
};

export default App;
